import type { OnyxComponentInputs, OnyxTableColumn } from '@onyx/angular';
import { MakeAndModelCellComponent } from '../../../../../common/components/cells/make-and-model-cell/make-and-model-cell.component';
import { StringCellComponent } from '../../../../../common/components/cells/string-cell/string-cell.component';
import { DictionaryCode } from '../../../../../common/enums/dictionary-code';
import type { BaseAssignedVehiclesFormGroup } from '../../base-form/base-assigned-vehicles-form/base-assigned-vehicles-form.component';
import { BaseVehicleCellComponent } from '../cells/base-vehicle-cell/base-vehicle-cell.component';

export const BASE_ASSIGNED_VEHICLES_FORM_COLUMNS: OnyxTableColumn<BaseAssignedVehiclesFormGroup>[] =
  [
    {
      id: 'vehicle',
      name: 'labels.vehicle',
      width: 'fill',
      component: {
        ref: BaseVehicleCellComponent,
        inputs: (data): OnyxComponentInputs<BaseVehicleCellComponent> => ({
          generalInformation:
            data.item.getRawValue().vehicle.generalInformation,
        }),
      },
    },
    {
      id: 'vehicleType',
      name: 'labels.vehicleType',
      width: '220px',
      component: {
        ref: StringCellComponent,
        inputs: (data): OnyxComponentInputs<StringCellComponent> => ({
          value: data.item.getRawValue().vehicle.generalInformation.category,
          dictionaryCode: DictionaryCode.VEHICLE_CATEGORY,
          color: 'gray',
        }),
      },
    },
    {
      id: 'makeAndModel',
      name: 'labels.makeAndModel',
      width: '230px',
      component: {
        ref: MakeAndModelCellComponent,
        inputs: (data): OnyxComponentInputs<MakeAndModelCellComponent> => ({
          make: data.item.getRawValue().vehicle.generalInformation.make,
          model: data.item.getRawValue().vehicle.generalInformation.model,
        }),
      },
    },
    {
      id: 'fuel',
      name: 'labels.fuel',
      width: '60px',
      component: {
        ref: StringCellComponent,
        inputs: (data): OnyxComponentInputs<StringCellComponent> => ({
          value: data.item.getRawValue().vehicle.fuelTankCapacity?.fuelType,
          dictionaryCode: DictionaryCode.FUEL_TYPE,
          color: 'gray',
        }),
      },
    },
  ];
